import React, { useEffect, useLayoutEffect, useMemo, useRef, useState } from 'react';

const TESTIMONIALS = [
  //   {
  //     quote:
  //       "We cut our compensation cycle prep time from 8 to 2 weeks because Sophare's pay equity analytics were finally push-of-a-button in the 4 countries we are required to report.",
  //     attribution: 'Director of Compensation, Transportation & Logistics Company',
  //   },
  {
    quote:
      "We did a dry run for the EU Pay Transparency Directive and it was a breeze! Sophare recommended we fix a few things in our job architecture and incentive programs to make sure we keep our gender pay gaps under the EU Directive's threshold come next June. Thank you Sophare team!",
    attribution: 'VP, Total Rewards, Consumer Goods Company',
  },
  //   {
  //     quote:
  //       'Our workforce planning now ties to actual labor costs instead of estimates. That alone changed how we budget our cost of labour. No one is really doing workforce planning like Sophare.',
  //     attribution: 'Head of HR Analytics, Financial Services Company',
  //   },
  //   {
  //     quote:
  //       'We previosuly used Sysarb and our budget to correct pay equity issues increased every year. The Sophare team led by Siena really understands this problem well and have solved the issue from the root cause: job levels. Love that we can also control the budget.',
  //     attribution: 'Chief People Officer, Energy Company',
  //   },
  {
    quote: 'Sophare is to pay transparency what Pave is to compensation planning!',
    attribution: 'Global Head of Compensation, Technology Company',
  },
  //   {
  //     quote: 'The scenario planning helped us respond to hiring freezes without missing critical roles.',
  //     attribution: 'SVP, Total Rewards, Technology Company',
  //   },
  //   {
  //     quote: 'We can spot comp issues early and fix them before they show up in public reports.',
  //     attribution: 'Head of People Operations, Manufacturing Company',
  //   },
  {
    quote: 'The EU transparency readiness checks are straightforward and give us a compliant analysis for equal pay.',
    attribution: 'Director, Total Rewards, Retail Company',
  },
  //   {
  //     quote:
  //       "Sophare's data cleaning and grouping capabilities are a game changer. Our previous vendor Syndio made us define the equal work groupings manually and clean the HRIS and payroll data - it was a mess before!",
  //     attribution: 'Head of HR, Media & Entertainment Company',
  //   },
  {
    quote:
      'We had a 1-week turnaround to submit a UK gender pay gap report. Sophare got it done in 2 days! Thank you Siena and team.',
    attribution: 'Chief Human Resources Officer, Financial Services Company',
  },
  //   {
  //     quote:
  //       'Sophare is the only pay equity platform built for employment legal teams as well as HR and Finance. Pay equity analysis is done under privilege and Sophare is the only platform that allows us to do that.',
  //     attribution: 'Employment Legal Counsel, Technology Company',
  //   },
];

const SWIPE_THRESHOLD_PX = 48;

const Testimonials = () => {
  const [startIndex, setStartIndex] = useState(0);
  const [offset, setOffset] = useState(1);
  const [isTransitioning, setIsTransitioning] = useState(false);
  const [pendingDirection, setPendingDirection] = useState(null);
  const transitionTimeoutRef = useRef(null);
  const swipeStartRef = useRef(null);
  const measureRefs = useRef([]);
  const [maxCardHeight, setMaxCardHeight] = useState(null);

  const showPrevious = () => {
    if (isTransitioning) return;
    setIsTransitioning(true);
    setPendingDirection('prev');
    setOffset(0);
  };

  const showNext = () => {
    if (isTransitioning) return;
    setIsTransitioning(true);
    setPendingDirection('next');
    setOffset(2);
  };

  const handleSwipeStart = (event) => {
    if (isTransitioning || !event.isPrimary) return;
    swipeStartRef.current = {
      x: event.clientX,
      y: event.clientY,
    };
    event.currentTarget.setPointerCapture?.(event.pointerId);
  };

  const handleSwipeEnd = (event) => {
    if (!swipeStartRef.current || !event.isPrimary) return;

    const deltaX = event.clientX - swipeStartRef.current.x;
    const deltaY = event.clientY - swipeStartRef.current.y;
    swipeStartRef.current = null;

    if (Math.abs(deltaX) < SWIPE_THRESHOLD_PX || Math.abs(deltaX) <= Math.abs(deltaY)) {
      return;
    }

    if (deltaX < 0) {
      showNext();
      return;
    }

    showPrevious();
  };

  const handleSwipeCancel = () => {
    swipeStartRef.current = null;
  };

  const completeTransition = (direction) => {
    if (!direction) return;
    setIsTransitioning(false);
    setPendingDirection(null);
    setOffset(1);
    setStartIndex((prev) => {
      if (direction === 'next') {
        return (prev + 1) % TESTIMONIALS.length;
      }
      return (prev - 1 + TESTIMONIALS.length) % TESTIMONIALS.length;
    });
  };

  useEffect(() => {
    if (!isTransitioning || !pendingDirection) return undefined;

    transitionTimeoutRef.current = setTimeout(() => {
      completeTransition(pendingDirection);
    }, 650);

    return () => {
      if (transitionTimeoutRef.current) {
        clearTimeout(transitionTimeoutRef.current);
        transitionTimeoutRef.current = null;
      }
    };
  }, [isTransitioning, pendingDirection]);

  useLayoutEffect(() => {
    const measure = () => {
      const heights = measureRefs.current.map((node) => (node ? Math.ceil(node.getBoundingClientRect().height) : 0));
      const nextMax = heights.length ? Math.max(...heights) : 0;
      if (nextMax && nextMax !== maxCardHeight) {
        setMaxCardHeight(nextMax);
      }
    };

    measure();
    window.addEventListener('resize', measure);

    return () => {
      window.removeEventListener('resize', measure);
    };
  }, [maxCardHeight]);

  const trackItems = useMemo(() => {
    const total = TESTIMONIALS.length;
    const getItem = (index) => {
      const wrappedIndex = (index + total) % total;
      return TESTIMONIALS[wrappedIndex];
    };

    return [
      getItem(startIndex - 1),
      getItem(startIndex),
      getItem(startIndex + 1),
      getItem(startIndex + 2),
      getItem(startIndex + 3),
    ];
  }, [startIndex]);

  return (
    <section aria-labelledby="leaders-heading" className="w-full bg-indigo-600 py-20">
      <div className="content max-w-[1120px] mx-auto">
        <div className="flex flex-col gap-6 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <p className="text-sm font-semibold tracking-widest text-indigo-100 uppercase">Why teams choose Sophare</p>
            <h2 id="leaders-heading" className="text-4xl sm:text-6xl font-bold tracking-tighter mt-3 text-white">
              Trusted by HR and legal teams preparing for pay transparency
            </h2>
          </div>
          <div className="flex items-center gap-3">
            <button
              type="button"
              onClick={showPrevious}
              aria-disabled={isTransitioning}
              aria-label="Previous testimonials"
              className="h-10 w-10 rounded-full border border-white/40 text-white hover:border-white/80 transition-colors"
            >
              <svg viewBox="0 0 24 24" className="h-5 w-5 mx-auto" aria-hidden="true">
                <path
                  d="M15 6l-6 6 6 6"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </button>
            <button
              type="button"
              onClick={showNext}
              aria-disabled={isTransitioning}
              aria-label="Next testimonials"
              className="h-10 w-10 rounded-full border border-white/40 text-white hover:border-white/80 transition-colors"
            >
              <svg viewBox="0 0 24 24" className="h-5 w-5 mx-auto" aria-hidden="true">
                <path
                  d="M9 6l6 6-6 6"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </button>
          </div>
        </div>

        <div className="mt-10 overflow-hidden">
          <div
            className="relative testimonials-carousel"
            onPointerDown={handleSwipeStart}
            onPointerUp={handleSwipeEnd}
            onPointerCancel={handleSwipeCancel}
          >
            <div className="absolute left-0 top-0 opacity-0 pointer-events-none -z-10">
              {TESTIMONIALS.map((item, index) => (
                <figure
                  key={`${item.attribution}-measure-${index}`}
                  ref={(node) => {
                    measureRefs.current[index] = node;
                  }}
                  className="rounded-2xl border border-gray-200 bg-gray-50 p-6 flex flex-col justify-between"
                  style={{
                    width: 'var(--card-width)',
                  }}
                >
                  <blockquote className="text-gray-800 text-base sm:text-lg leading-relaxed">“{item.quote}”</blockquote>
                  <figcaption className="mt-6 text-sm font-medium text-gray-600">— {item.attribution}</figcaption>
                </figure>
              ))}
            </div>
            <div
              className="flex"
              style={{
                '--offset': offset,
                gap: 'var(--gap)',
                transform: 'translateX(calc(var(--side-gutter) - (var(--offset) * var(--step))))',
                transition: isTransitioning ? 'transform 500ms ease' : 'none',
              }}
              onTransitionEnd={() => {
                completeTransition(pendingDirection);
              }}
            >
              {trackItems.map((item, index) => (
                <figure
                  key={`${item.attribution}-${index}`}
                  className="rounded-2xl border border-gray-200 bg-gray-50 p-6 flex flex-col justify-between"
                  style={{
                    flex: '0 0 var(--card-width)',
                    minHeight: maxCardHeight ? `${maxCardHeight}px` : undefined,
                  }}
                >
                  <blockquote className="text-gray-800 text-base sm:text-lg leading-relaxed">“{item.quote}”</blockquote>
                  <figcaption className="mt-6 text-sm font-medium text-gray-600">— {item.attribution}</figcaption>
                </figure>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
